
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutu4NFYP1RSfYEg5u9R8QZlgT5G3WP8sX9BD5pMIswV1kMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/about.vue?macro=true";
import { default as indexA4oYCY_fP9Z8iwf6aPhFfOufAe1YaHcDUwHi0UpMk8MMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/index.vue?macro=true";
import { default as loginARxtjhYqd1UYZ3ToOtdeZ3NY7xQZMumFuv__GoQOa4MMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/login.vue?macro=true";
import { default as gift_45cardsWIp1kY_3XNPxvg8sxuTZyQ8FN5Obq4FDiVgfngBi_9gMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/terms/gift-cards.vue?macro=true";
import { default as termsRs33x1qM07n5qJDpptQYdiJypsdXZuv7Hfga_i_3IvQMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/terms.vue?macro=true";
import { default as contact0WDiG5lfsDLOuD3j5k4ZrDV8Kbt1u8Dnhfd3I3XHTGMMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/contact.vue?macro=true";
import { default as privacy8CkWaHNpZR_61yTxT83sY2KyLiI2IEQo5GSpQ_a0lTMMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/privacy.vue?macro=true";
import { default as index_0nHczgVD2ntSg05JFqmG9qxDh1Lvsra4NKA2u6KLAAMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/index.vue?macro=true";
import { default as dashboardsdXkhAz2u2f94j7leXW7_IjUPNGrUS1UidXKAYETLO4Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/dashboard.vue?macro=true";
import { default as index6Y_QtoJsuAktFMRkdT4w53SL869K41iV5PdRHlB2HvcMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/help/index.vue?macro=true";
import { default as profileNBDeWpSqH0rDpv6Q3X8YXlKA3Suu2_qNRRNYIEOIkN8Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/profile.vue?macro=true";
import { default as _91slug_936KmO4NNFJoaMMF8iUphdI0BSZ4Cq_Q15wiF0AmaTvJwMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/help/[slug].vue?macro=true";
import { default as mobile_45homeXxj_50t4MSIlQ6YCqGnmU1Mf1xvw0kEEmdFtnZutAiQMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/mobile-home.vue?macro=true";
import { default as register2oSldcnR74IAO7W0xV388ZO_Q1xnlL15aRl_8jkWrmwMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/register.vue?macro=true";
import { default as restaurantslyEwc_gM6PG72MzB4GzHwbUQF_wsvMEmn_QlZ8neKnAMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/restaurants.vue?macro=true";
import { default as second_45page5rcQy8zOw7RjxwQCF9rXtm7Tk62g1dhWQdAXfYI6X5kMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/second-page.vue?macro=true";
import { default as indexXyqA0dZ64ERDSDKBvPNeeHY8rRF8wGRQPGzb_YUpRQAMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/index.vue?macro=true";
import { default as staffeg7Oi_blTzrzX4eF2SOdBx9Glx6NWy7YEb813ca4hi0Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/staff.vue?macro=true";
import { default as unavailable48VitFfir_eCfr2Xkd2ltwFJrw3_1wTPMCaovXygjSoMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/unavailable.vue?macro=true";
import { default as why_45starvlyqPiZ7bpHeErSZnYAuLgYrdMN4InHDLBTzGsDJyK_FcEMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/why-starvly.vue?macro=true";
import { default as faqyjmbcYxVNPPx7zxSKkSo8DVj0NdW0XXg8E0HVSsffDwMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/faq.vue?macro=true";
import { default as kdscWws4VpDYesYSvos4uZtkWgx77GzUrW7E_NB2vPSvIcMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/kds.vue?macro=true";
import { default as indexAwUec9ql_0u51na7THxS_JNjqHsMMGLxbIhwrmwY_FgMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/index.vue?macro=true";
import { default as dealsTFRJkMMwsKIfBe5kXZPQrb_3pqVKQEBPWikY4eYgzcYMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/deals.vue?macro=true";
import { default as kioskm9_ybOgHT0Ma9dJuR10FO0EBbAAbYwJyEMLm0eaMXFgMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/kiosk.vue?macro=true";
import { default as not_45authorizedUK9IrlsC1Jnx6e6oTeMrfP6m2Z_EEgqRo1rfClN5FjgMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/not-authorized.vue?macro=true";
import { default as order_45feedbackwhhDuILpykpbNnAmz5pGaxJyNYwGs__mnbX5ghcNJZEMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/order-feedback.vue?macro=true";
import { default as _91token_93tvlzVbk6fNNCZOarZDTo1KwKriUPTKbXwhKKEBrsyt8Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/verify/[token].vue?macro=true";
import { default as driver_u3Wa8w2ZUXRHv5Ke39Fz_opilcGZ_w6KoHVZvHYxkMMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/delivery/driver.vue?macro=true";
import { default as forgot_45passwordGt0O_4sDgPKPoAEmNPBw_OiRUW4bJnvi5gxRuri5SPIMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/forgot-password.vue?macro=true";
import { default as indexe_QQEV7AOajku_x6sQ_W666tHoerIod3vzQdFPDM_0AMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/orders/index.vue?macro=true";
import { default as campaignsITZXnmM6qC38lRhz3tDnByrXDW5efqXOPaK3zaf9USwMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/campaigns.vue?macro=true";
import { default as impersonatedcysPsnBEYAzPhyVDfem34Yc4lz6s_Y9j_diYsgY9ugMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/auth/impersonate.vue?macro=true";
import { default as pendingSVBfalV_X16W6gx7OJJ3WNmG6dqw66bYQgACtz9Mw7sMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/pending.vue?macro=true";
import { default as pricinguk_dH3iKB_F6DOWevzoRQayWOj4XWMxOjOBFbp5TeJYMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/pricing.vue?macro=true";
import { default as profileYwnH9MfEXgxgsEFdZN_COBkbJLYY7NpqGzwnmleVkToMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/profile.vue?macro=true";
import { default as businessesX6we13UI_jf78Xy6NDx23b4hlJMZUxNYVU_Ede9Z63UMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/businesses.vue?macro=true";
import { default as gift_45cardsgDzistAiaHttCfDFG7E7FbT3Q_bR2aHFn_yONSxnpnAMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/gift-cards.vue?macro=true";
import { default as callbackv4zMTMxIuBzdm_Prh5lgu9A6rZ40KvihYJKo_Jf9XPkMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/callback.vue?macro=true";
import { default as invoicesev_lXy6Z8tpBcrCFAyfsfuDzSVuiPpAhHtuJY5Dd_KQMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/invoices.vue?macro=true";
import { default as settingsEtg24_FFZonVRXIORRo_HwLzWHqLmg3I2pVE5BZ3lFUMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/settings.vue?macro=true";
import { default as register_45businessqgvi6oqKDQsqpXgqMTd4JfsZC_tjqlMsBqAskKW0LXgMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/register-business.vue?macro=true";
import { default as adjustmentsQqq1TwhGTYkrawbLa44YIVC2skrDe4_04a4pBAKsXRwMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/adjustments.vue?macro=true";
import { default as indexyKQiD0XjiPHuIH8vrBXv1UiMvSa0MJEjpN5PQze61_UMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/index.vue?macro=true";
import { default as analyticsj9WT40ALB5jrHgPJeNvluUzwBxwkfkdgludJc_kNv9kMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/analytics.vue?macro=true";
import { default as indexbqWwwqK6wABtHpXB5toR896DKLFXv90kF1w144sXrKsMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/favorites/index.vue?macro=true";
import { default as _91businessSlug_93b4mDk4RAZBRXldcoVorQRkkBXyxzMWKZ3g0WLozlwdAMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/book/[businessSlug].vue?macro=true";
import { default as craftRvOpn3V_6cMp_Lb3w_g1w_yaFrldD6LdqRIlOC0KD4cMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/craft.vue?macro=true";
import { default as indexEhGXEwZohCmxGB2jLFS5vF_gA8GEaHsnhQrb8ypjB9IMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/index.vue?macro=true";
import { default as indexyeZBEPKRBEUyd7lpqFE_BOhvGt8LlZN0cdANdlURJ6oMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/deals/index.vue?macro=true";
import { default as alertsU5P5gG5uy54u4rSTU_DTUE2ETt96A2RvCk38A8hdQKMMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/alerts.vue?macro=true";
import { default as groupsodoA3tRAL_UQ31ZlBvUAs9QrQx4NzSPlMGuwtJc_7aIMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/groups.vue?macro=true";
import { default as newvbAHAio_3naT3VBS6LkUR2V_OukqBtCkddweMIB1ILMMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/voucher/new.vue?macro=true";
import { default as qr_45orderingj6q7oMdyqPFIGL4UDY7gsR9LMhatK1g2VA_UiFZ2ACcMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/qr-ordering.vue?macro=true";
import { default as track0JfYhU8wFFaFgtM01pOiHrBnGYHgdi7rTRKp5Ns9aQ0Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/orders/[id]/track.vue?macro=true";
import { default as _91businessSlug_93_AB8_nCaKrfF5DAJYSFIx7ANG7Mnl893dBEcj1rKm1sMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/order/[businessSlug].vue?macro=true";
import { default as payment_45returnJFxWePuoqtiV9Dh1almvuMxqIk5wqU_zxP_0HuWeqY8Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/order/payment-return.vue?macro=true";
import { default as audittDhpUIi_poem72L4Ipc2KQz5jktGhDxnXLl9KLLh6z4Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/rustdesk/audit.vue?macro=true";
import { default as index2M_vK3BNwlO9rxmfk5xhJjc2njr2NLFX9fsEXBNkDhYMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/rustdesk/index.vue?macro=true";
import { default as qrVukeuPS9R9eL4kXdAhbyliMOAvgX5lRXsOQlnf42VasMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/qr.vue?macro=true";
import { default as indexgeWRZsdapBNrd9ePxzLT_C4Gcw0GqNjkrM5_Tdy2TJUMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/export/index.vue?macro=true";
import { default as indexQJmh_pV9pdVwEZuSVfRxf2eXf1l_mX6MOxit0PKaeNMMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/import/index.vue?macro=true";
import { default as index1S7QWLsax7dQKlDXiCmtmHpnpMvIerbG_eYN45aZrVsMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/orders/index.vue?macro=true";
import { default as content7k3Zybq5lYRwSnifG2_2tLeq_4V_96Hts3AW_aJJWr0Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/[id]/content.vue?macro=true";
import { default as _91id_93UU4db4KZ1ZGHjzF2c_ATLAU_9fJnQHxxQYGro_quC9QMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/[id].vue?macro=true";
import { default as reservationsx5eEuMfksg1mUNrAg57Gd_YjDOSJY_rQ7MV2usRP1tYMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/reservations.vue?macro=true";
import { default as deployJTqfLTnh_LYBpV4pKE_qYfd_NEBD4lI4Yz3NB7esM_oMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/rustdesk/deploy.vue?macro=true";
import { default as _91id_93Sk__DtWsJy6X25PddwgBI3OpkW78Spz1Wg_vHhh4NUQMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/statements/[id].vue?macro=true";
import { default as poscEgYc5jsvPo2srb4cZx9E6i2Qig3QsvHTaA5NgHCe18Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/pos.vue?macro=true";
import { default as indexl0UTmEe92XMqUclexoHnB8UTFFlmOxgMcxE0AHm_1TIMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/manager/index.vue?macro=true";
import { default as staffZAsXIROH17m67M0QCLCkc0bKsr97NeHPkFiefjuignIMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/manager/staff.vue?macro=true";
import { default as indexbcxJ82k_PreVNi4GNpIyKnyKChFOamFrb6F6ewRb67YMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/index.vue?macro=true";
import { default as rules3d2u1ZNKmRUqTHZ3gvcmkONjukvc2f89kPaZ7NIMT3YMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/rules.vue?macro=true";
import { default as indexj9KtoeztIksJULlIvhLez5JH_J_5z_klLC7v1UcKXJwMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/voucher/index.vue?macro=true";
import { default as point_45of_45saleA_94iM3vanEOwjLv5gwa6pnZdNWOnnZZbnX_t953mEcMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/point-of-sale.vue?macro=true";
import { default as invoiceZh7ldZ1zkjtYWREa2xc_kz_1igr4CV_WmVhTehHVxZwMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/orders/[id]/invoice.vue?macro=true";
import { default as devicesFz0bLjcqAkqdARPIWpUmosDRlm0wmlD316ixf0dg1M4Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/rustdesk/devices.vue?macro=true";
import { default as serversBMGxPjlob3kwNGba_S6cZxWCsKkk18VcKz0ujujUywcMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/rustdesk/servers.vue?macro=true";
import { default as indexhLTs_hzHU7I0KFOADlayjLweor6rvywOdAGfO45UnGMMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/statements/index.vue?macro=true";
import { default as add_45editAhP4Y3qXUgpzvM8F8lduWa5X7lox_GMbMlpO4AFSmAcMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/deals/add-edit.vue?macro=true";
import { default as _91id_93hHncksF3_oesYkAsdNs70kLH0qCIRmY8Mp8oVr8iQDUMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/floorplan/[id].vue?macro=true";
import { default as rosterxTI18D6JSXOFfSHdWMeG4RvhulmQtltZw6p4qwln3IIMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/manager/roster.vue?macro=true";
import { default as indexSXSa2Y1rvizoevly2NUO38I6RsK0ak5FKMPRhtD1_v4Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/add/index.vue?macro=true";
import { default as modifiersdffb0mL6sXOagJVtQjPpIRW51siaFZfR_nKcKdQKbpQMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/modifiers.vue?macro=true";
import { default as reports6GunxM1HHIlxKI_cElenvVrbDZZXiXAY48ISwIoxKhsMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/orders/reports.vue?macro=true";
import { default as promoslcCXsh3j_h1WQWIZTdSRz8kj_VBOxYiGg5_dY1nlj_4Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/promos.vue?macro=true";
import { default as kiosk_qZZHXe3i9yoqzQr3xAE0wbmJIECGUFyleXz2kYeqMUMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/kiosk.vue?macro=true";
import { default as indexZPAbpESbc0aKeIjE_ZqvPxxp69e047nunEkP6vg5_TMMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/floorplan/index.vue?macro=true";
import { default as indexYMiyf4DMzt9DakAdRaKHjX3MI17ayFGq9Oh80DACgPQMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/inventory/index.vue?macro=true";
import { default as indexGbM_Wpe3ARXd6CzWQ0tEQiSajObrTs2Rw766WHEHnjIMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/marketing/index.vue?macro=true";
import { default as categoriesVXFyJRu5VSZVs7jiwOkDRSBx0difoz3Q4mTIXSat5s8Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/categories.vue?macro=true";
import { default as indexaqdm4XiRTEaqQNFJZgqHEbFG9YsNK1Cf8niroAD9nGAMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/list/index.vue?macro=true";
import { default as payment_45methodsvDFI_wdqykJIyF_1tZjWxp4ey1dvXEMZsWJ5cmJ8p5QMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/payment-methods.vue?macro=true";
import { default as contentDnyDeEhDuUtI9GxX5kWETYBGR_v5UJI18aF_r_NROgoMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/content.vue?macro=true";
import { default as menu_45managementic9gh_h9CZMFlWdwqrhtrKN_M6JB77s_oPClUNfa7dsMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/menu-management.vue?macro=true";
import { default as online_45orderingVQ5M_IhzUygscex3nR_mVyr31A56GLfJHqdM_eDgEwgMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/online-ordering.vue?macro=true";
import { default as indexNpkBURv7codJKJl4tdPKpR1bQZeR3DJLt4RVmZdkWY0Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/payment-methods/index.vue?macro=true";
import { default as labelsb9_KcCy0lRHctXG0HREJFXRrrjblXv111zPTkkt8EowMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/floorplan/labels.vue?macro=true";
import { default as modifyjRe_S_jFWK2nGq_e_KKbmq5oBS_wG2uDueOy7wIx6DoMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/[id]/modify.vue?macro=true";
import { default as staff_45management0fGDez4FesOvYKj5pNKtY2FWnlrD1aoYQP4S8Hkh2kIMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/staff-management.vue?macro=true";
import { default as fees2nJclun6OqDkxKN1vZ44mo59mrVguBOAV389b6eppFoMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/fees.vue?macro=true";
import { default as indexgr_5BjJvprgF_iC3ZPeclCH_MAjX0JhA5XTNkW_PdG0Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/loyalty/index.vue?macro=true";
import { default as reportsw2OfIIjDHLA2db4FPC35Af_miAqaGWzYz9Qme0zcDK0Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/marketing/reports.vue?macro=true";
import { default as payment_45terminalspdwyXjlbf3Y3v7QzMCl_EbQf_AoWkC_Twso_d2YzsZoMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/payment-terminals.vue?macro=true";
import { default as analyticsZdhLySYarKydM9kAoasEYof26Bm69NKwHvvNGn7g5goMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/analytics.vue?macro=true";
import { default as _91id_938TQVUK_FQtiM9wNyT1MtK87nBAssRjZ4kO0lpJulC7IMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/billing-statements/[id].vue?macro=true";
import { default as billing_45statements6GtN_bDPfp7bD_6vQwMQhPB0tEEcXkeQv1Tl__JFsk4Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/billing-statements.vue?macro=true";
import { default as trackers38CKomEv5hDCtGO_xvddvnJXrKjJgANUkBE_6xuUMAsMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/trackers.vue?macro=true";
import { default as _91id_93yFuxOZJSeo0ft_w2MY3zftWWM6_habAUzx21ijnYbekMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/campaigns/[id].vue?macro=true";
import { default as _91id_936Lw4BEWaoIVYb2YYsAzN4_hjho_aIXUSLBIVeYZoL0QMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/customers/[id].vue?macro=true";
import { default as _91id_93JpvsB0DLsqxDfjfr_KalP1i8PWPvejbw7EE17wsp8JIMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/templates/[id].vue?macro=true";
import { default as patronectlSHyiSzDTdK0qTzfbrOIdTXq0D4Yru4WUc0_c61_fv0Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/patronect.vue?macro=true";
import { default as index_OcJO9hDL1h40mvZ1jMfX2d3l6kbGLN9j2gq2CjQlgYMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/campaigns/index.vue?macro=true";
import { default as indexlz0SNzw_vv3aaJ7PTBev773SAkosGn4Y_aJMdx5sm48Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/customers/index.vue?macro=true";
import { default as indexjfHhFNlPqLdYO9JcqdWwtWMBfCnM8wdRvE472CETyzwMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/templates/index.vue?macro=true";
import { default as ws_45simulatorrn2d_e5Z_t3IdzQhAciI_NDO0gz6v2aykvYAa4OE3AkMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/orders/ws-simulator.vue?macro=true";
import { default as payment_45allocationsEkpXbTe9ZmGAc9zihik5BBCMoJXR_y09ose_CFh_7y8Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/payment-allocations.vue?macro=true";
import { default as delivery_45management2BiA0c_8wnh_C3YbSGAaakQrdHYkQtngC2qrc0qEJM4Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/delivery-management.vue?macro=true";
import { default as coursesDB4u8e7lcprJ4tZSoh2tND1u57JFFDWMO3nr64a0va4Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/courses.vue?macro=true";
import { default as createiDzorYOA1tw96WhkDslZDx15llWpQScV1Cms4NCwds0Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/campaigns/create.vue?macro=true";
import { default as createBojieKKxJbMlfCyugtQTrRzhH7mAVgcA4cfYRjWigA0Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/templates/create.vue?macro=true";
import { default as promo_45editorhKuEBrIcsfDC8Q0YFR6U9gW3UzKzjG1fFUSjExrSr9oMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/promo-editor.vue?macro=true";
import { default as _91id_93qklX2G4yhiaTdDY_bTAbVGZha9brdq619vOaqbwIPe0Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/templates/[id].vue?macro=true";
import { default as customer_45relationshipsQPoLfNp2XSz0L5VTuumY9F3Go64A06GkYssV1lLER8QMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/customer-relationships.vue?macro=true";
import { default as order_45tabletstAJJy5ljWDLbRF81VbPgYZoaWlotykmefyo_tHRdCoAMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/order-tablets.vue?macro=true";
import { default as indexZHWzPOhiNiFfWICIOTPErVWZwxaCJg946zZmanWyikYMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/templates/index.vue?macro=true";
import { default as _91id_93Roo1ydFRY1Lv0hI0wv5shW5x7PLdjpvOqRUuV75n1nIMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/menu-boards/[id].vue?macro=true";
import { default as integrations6VyWJozeYGAFy4iGmn4J9e1OA_fvmKa5C6XuwYV9UD4Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/integrations.vue?macro=true";
import { default as reservations3g1_xPgJDy95n9Jwly_Cn7GvzYOhMIzsoczUY23rniEMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/reservations.vue?macro=true";
import { default as indexfA_M0jTdt48W9rZRwf_bV_f24gHbmfqvtAr1xp0zCusMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/menu-boards/index.vue?macro=true";
import { default as staff_45hours_45reportHKU_1qnGNpV75axV10L91zR7donOND1PKuahqBjysi8Meta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/manager/staff-hours-report.vue?macro=true";
import { default as payment_45reconciliationIRSWrHMGpTaUom1awgjRzUEigK9VobcqbysdpL2R7rkMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[id]/payment-reconciliation.vue?macro=true";
import { default as operating_45hours0SHsXy8Jh2oC41_j7FqYEC472ZUxxnYdWNy_gHOsIGkMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/operating-hours.vue?macro=true";
import { default as payment_45connectCNo4KlEPEbj_XVvODXaWHDo8SQsLhQfHV_Oo4OW0MBgMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/payment-connect.vue?macro=true";
import { default as booking_45settingsZhy6nvesPKBXUs12rpkFhflhQE38D1MEtFjUtZy9wWEMeta } from "/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/booking-settings.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutu4NFYP1RSfYEg5u9R8QZlgT5G3WP8sX9BD5pMIswV1kMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexA4oYCY_fP9Z8iwf6aPhFfOufAe1YaHcDUwHi0UpMk8MMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginARxtjhYqd1UYZ3ToOtdeZ3NY7xQZMumFuv__GoQOa4MMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsRs33x1qM07n5qJDpptQYdiJypsdXZuv7Hfga_i_3IvQMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/terms.vue"),
    children: [
  {
    name: "terms-gift-cards",
    path: "gift-cards",
    meta: gift_45cardsWIp1kY_3XNPxvg8sxuTZyQ8FN5Obq4FDiVgfngBi_9gMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/terms/gift-cards.vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    meta: contact0WDiG5lfsDLOuD3j5k4ZrDV8Kbt1u8Dnhfd3I3XHTGMMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/contact.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacy8CkWaHNpZR_61yTxT83sY2KyLiI2IEQo5GSpQ_a0lTMMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/privacy.vue")
  },
  {
    name: "my",
    path: "/my",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardsdXkhAz2u2f94j7leXW7_IjUPNGrUS1UidXKAYETLO4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/dashboard.vue")
  },
  {
    name: "help",
    path: "/help",
    meta: index6Y_QtoJsuAktFMRkdT4w53SL869K41iV5PdRHlB2HvcMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/help/index.vue")
  },
  {
    name: "my-profile",
    path: "/my/profile",
    meta: { ...(profileNBDeWpSqH0rDpv6Q3X8YXlKA3Suu2_qNRRNYIEOIkN8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/profile.vue")
  },
  {
    name: "help-slug",
    path: "/help/:slug()",
    meta: _91slug_936KmO4NNFJoaMMF8iUphdI0BSZ4Cq_Q15wiF0AmaTvJwMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/help/[slug].vue")
  },
  {
    name: "mobile-home",
    path: "/mobile-home",
    meta: mobile_45homeXxj_50t4MSIlQ6YCqGnmU1Mf1xvw0kEEmdFtnZutAiQMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/mobile-home.vue")
  },
  {
    name: "my-register",
    path: "/my/register",
    meta: register2oSldcnR74IAO7W0xV388ZO_Q1xnlL15aRl_8jkWrmwMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/register.vue")
  },
  {
    name: "restaurants",
    path: "/restaurants",
    meta: restaurantslyEwc_gM6PG72MzB4GzHwbUQF_wsvMEmn_QlZ8neKnAMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/restaurants.vue")
  },
  {
    name: "second-page",
    path: "/second-page",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/second-page.vue")
  },
  {
    name: "super",
    path: "/super",
    meta: { ...(indexXyqA0dZ64ERDSDKBvPNeeHY8rRF8wGRQPGzb_YUpRQAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/index.vue")
  },
  {
    name: "super-staff",
    path: "/super/staff",
    meta: { ...(staffeg7Oi_blTzrzX4eF2SOdBx9Glx6NWy7YEb813ca4hi0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/staff.vue")
  },
  {
    name: "unavailable",
    path: "/unavailable",
    meta: unavailable48VitFfir_eCfr2Xkd2ltwFJrw3_1wTPMCaovXygjSoMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/unavailable.vue")
  },
  {
    name: "why-starvly",
    path: "/why-starvly",
    meta: why_45starvlyqPiZ7bpHeErSZnYAuLgYrdMN4InHDLBTzGsDJyK_FcEMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/why-starvly.vue")
  },
  {
    name: "business-faq",
    path: "/business/faq",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/faq.vue")
  },
  {
    name: "features-kds",
    path: "/features/kds",
    meta: kdscWws4VpDYesYSvos4uZtkWgx77GzUrW7E_NB2vPSvIcMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/kds.vue")
  },
  {
    name: "business",
    path: "/business",
    meta: { ...(indexAwUec9ql_0u51na7THxS_JNjqHsMMGLxbIhwrmwY_FgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/index.vue")
  },
  {
    name: "features-deals",
    path: "/features/deals",
    meta: dealsTFRJkMMwsKIfBe5kXZPQrb_3pqVKQEBPWikY4eYgzcYMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/deals.vue")
  },
  {
    name: "features-kiosk",
    path: "/features/kiosk",
    meta: kioskm9_ybOgHT0Ma9dJuR10FO0EBbAAbYwJyEMLm0eaMXFgMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/kiosk.vue")
  },
  {
    name: "not-authorized",
    path: "/not-authorized",
    meta: not_45authorizedUK9IrlsC1Jnx6e6oTeMrfP6m2Z_EEgqRo1rfClN5FjgMeta || {},
    alias: ["/pages/misc/not-authorized"],
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/not-authorized.vue")
  },
  {
    name: "order-feedback",
    path: "/order-feedback",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/order-feedback.vue")
  },
  {
    name: "verify-token",
    path: "/verify/:token()",
    meta: _91token_93tvlzVbk6fNNCZOarZDTo1KwKriUPTKbXwhKKEBrsyt8Meta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/verify/[token].vue")
  },
  {
    name: "delivery-driver",
    path: "/delivery/driver",
    meta: driver_u3Wa8w2ZUXRHv5Ke39Fz_opilcGZ_w6KoHVZvHYxkMMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/delivery/driver.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordGt0O_4sDgPKPoAEmNPBw_OiRUW4bJnvi5gxRuri5SPIMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/forgot-password.vue")
  },
  {
    name: "my-orders",
    path: "/my/orders",
    meta: indexe_QQEV7AOajku_x6sQ_W666tHoerIod3vzQdFPDM_0AMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/orders/index.vue")
  },
  {
    name: "super-campaigns",
    path: "/super/campaigns",
    meta: { ...(campaignsITZXnmM6qC38lRhz3tDnByrXDW5efqXOPaK3zaf9USwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/campaigns.vue")
  },
  {
    name: "auth-impersonate",
    path: "/auth/impersonate",
    meta: impersonatedcysPsnBEYAzPhyVDfem34Yc4lz6s_Y9j_diYsgY9ugMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/auth/impersonate.vue")
  },
  {
    name: "business-pending",
    path: "/business/pending",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/pending.vue")
  },
  {
    name: "business-pricing",
    path: "/business/pricing",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/pricing.vue")
  },
  {
    name: "business-profile",
    path: "/business/profile",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/profile.vue")
  },
  {
    name: "super-businesses",
    path: "/super/businesses",
    meta: { ...(businessesX6we13UI_jf78Xy6NDx23b4hlJMZUxNYVU_Ede9Z63UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/businesses.vue")
  },
  {
    name: "super-gift-cards",
    path: "/super/gift-cards",
    meta: { ...(gift_45cardsgDzistAiaHttCfDFG7E7FbT3Q_bR2aHFn_yONSxnpnAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/gift-cards.vue")
  },
  {
    name: "business-callback",
    path: "/business/callback",
    meta: callbackv4zMTMxIuBzdm_Prh5lgu9A6rZ40KvihYJKo_Jf9XPkMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/callback.vue")
  },
  {
    name: "business-invoices",
    path: "/business/invoices",
    meta: invoicesev_lXy6Z8tpBcrCFAyfsfuDzSVuiPpAhHtuJY5Dd_KQMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/invoices.vue")
  },
  {
    name: "business-settings",
    path: "/business/settings",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/settings.vue")
  },
  {
    name: "register-business",
    path: "/register-business",
    meta: register_45businessqgvi6oqKDQsqpXgqMTd4JfsZC_tjqlMsBqAskKW0LXgMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/register-business.vue")
  },
  {
    name: "super-adjustments",
    path: "/super/adjustments",
    meta: { ...(adjustmentsQqq1TwhGTYkrawbLa44YIVC2skrDe4_04a4pBAKsXRwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/adjustments.vue")
  },
  {
    name: "business-crm",
    path: "/business/crm",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/index.vue")
  },
  {
    name: "features-analytics",
    path: "/features/analytics",
    meta: analyticsj9WT40ALB5jrHgPJeNvluUzwBxwkfkdgludJc_kNv9kMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/analytics.vue")
  },
  {
    name: "my-favorites",
    path: "/my/favorites",
    meta: indexbqWwwqK6wABtHpXB5toR896DKLFXv90kF1w144sXrKsMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/favorites/index.vue")
  },
  {
    name: "book-businessSlug",
    path: "/book/:businessSlug()",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/book/[businessSlug].vue")
  },
  {
    name: "business-menu-craft",
    path: "/business/menu/craft",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/craft.vue")
  },
  {
    name: "business-menu",
    path: "/business/menu",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/index.vue")
  },
  {
    name: "business-deals",
    path: "/business/deals",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/deals/index.vue")
  },
  {
    name: "business-menu-alerts",
    path: "/business/menu/alerts",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/alerts.vue")
  },
  {
    name: "business-menu-groups",
    path: "/business/menu/groups",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/groups.vue")
  },
  {
    name: "business-voucher-new",
    path: "/business/voucher/new",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/voucher/new.vue")
  },
  {
    name: "features-qr-ordering",
    path: "/features/qr-ordering",
    meta: qr_45orderingj6q7oMdyqPFIGL4UDY7gsR9LMhatK1g2VA_UiFZ2ACcMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/qr-ordering.vue")
  },
  {
    name: "my-orders-id-track",
    path: "/my/orders/:id()/track",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/orders/[id]/track.vue")
  },
  {
    name: "order-businessSlug",
    path: "/order/:businessSlug()",
    meta: _91businessSlug_93_AB8_nCaKrfF5DAJYSFIx7ANG7Mnl893dBEcj1rKm1sMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/order/[businessSlug].vue")
  },
  {
    name: "order-payment-return",
    path: "/order/payment-return",
    meta: payment_45returnJFxWePuoqtiV9Dh1almvuMxqIk5wqU_zxP_0HuWeqY8Meta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/order/payment-return.vue")
  },
  {
    name: "super-rustdesk-audit",
    path: "/super/rustdesk/audit",
    meta: { ...(audittDhpUIi_poem72L4Ipc2KQz5jktGhDxnXLl9KLLh6z4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/rustdesk/audit.vue")
  },
  {
    name: "super-rustdesk",
    path: "/super/rustdesk",
    meta: { ...(index2M_vK3BNwlO9rxmfk5xhJjc2njr2NLFX9fsEXBNkDhYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/rustdesk/index.vue")
  },
  {
    name: "business-configure-qr",
    path: "/business/configure/qr",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/qr.vue")
  },
  {
    name: "business-export",
    path: "/business/export",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/export/index.vue")
  },
  {
    name: "business-import",
    path: "/business/import",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/import/index.vue")
  },
  {
    name: "business-orders",
    path: "/business/orders",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/orders/index.vue")
  },
  {
    name: "business-signage-id",
    path: "/business/signage/:id()",
    meta: { ...(_91id_93UU4db4KZ1ZGHjzF2c_ATLAU_9fJnQHxxQYGro_quC9QMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/[id].vue"),
    children: [
  {
    name: "business-signage-id-content",
    path: "content",
    meta: { ...(content7k3Zybq5lYRwSnifG2_2tLeq_4V_96Hts3AW_aJJWr0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/[id]/content.vue")
  }
]
  },
  {
    name: "features-reservations",
    path: "/features/reservations",
    meta: reservationsx5eEuMfksg1mUNrAg57Gd_YjDOSJY_rQ7MV2usRP1tYMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/reservations.vue")
  },
  {
    name: "super-rustdesk-deploy",
    path: "/super/rustdesk/deploy",
    meta: { ...(deployJTqfLTnh_LYBpV4pKE_qYfd_NEBD4lI4Yz3NB7esM_oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/rustdesk/deploy.vue")
  },
  {
    name: "super-statements-id",
    path: "/super/statements/:id()",
    meta: { ...(_91id_93Sk__DtWsJy6X25PddwgBI3OpkW78Spz1Wg_vHhh4NUQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/statements/[id].vue")
  },
  {
    name: "business-configure-pos",
    path: "/business/configure/pos",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/pos.vue")
  },
  {
    name: "business-manager",
    path: "/business/manager",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/manager/index.vue")
  },
  {
    name: "business-manager-staff",
    path: "/business/manager/staff",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/manager/staff.vue")
  },
  {
    name: "business-signage",
    path: "/business/signage",
    meta: { ...(indexbcxJ82k_PreVNi4GNpIyKnyKChFOamFrb6F6ewRb67YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/index.vue")
  },
  {
    name: "business-signage-rules",
    path: "/business/signage/rules",
    meta: { ...(rules3d2u1ZNKmRUqTHZ3gvcmkONjukvc2f89kPaZ7NIMT3YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/rules.vue")
  },
  {
    name: "business-voucher",
    path: "/business/voucher",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/voucher/index.vue")
  },
  {
    name: "features-point-of-sale",
    path: "/features/point-of-sale",
    meta: point_45of_45saleA_94iM3vanEOwjLv5gwa6pnZdNWOnnZZbnX_t953mEcMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/point-of-sale.vue")
  },
  {
    name: "my-orders-id-invoice",
    path: "/my/orders/:id()/invoice",
    meta: invoiceZh7ldZ1zkjtYWREa2xc_kz_1igr4CV_WmVhTehHVxZwMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/orders/[id]/invoice.vue")
  },
  {
    name: "super-rustdesk-devices",
    path: "/super/rustdesk/devices",
    meta: { ...(devicesFz0bLjcqAkqdARPIWpUmosDRlm0wmlD316ixf0dg1M4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/rustdesk/devices.vue")
  },
  {
    name: "super-rustdesk-servers",
    path: "/super/rustdesk/servers",
    meta: { ...(serversBMGxPjlob3kwNGba_S6cZxWCsKkk18VcKz0ujujUywcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/rustdesk/servers.vue")
  },
  {
    name: "super-statements",
    path: "/super/statements",
    meta: { ...(indexhLTs_hzHU7I0KFOADlayjLweor6rvywOdAGfO45UnGMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/super/statements/index.vue")
  },
  {
    name: "business-deals-add-edit",
    path: "/business/deals/add-edit",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/deals/add-edit.vue")
  },
  {
    name: "business-floorplan-id",
    path: "/business/floorplan/:id()",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/floorplan/[id].vue")
  },
  {
    name: "business-manager-roster",
    path: "/business/manager/roster",
    meta: rosterxTI18D6JSXOFfSHdWMeG4RvhulmQtltZw6p4qwln3IIMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/manager/roster.vue")
  },
  {
    name: "business-menu-add",
    path: "/business/menu/add",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/add/index.vue")
  },
  {
    name: "business-menu-modifiers",
    path: "/business/menu/modifiers",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/modifiers.vue")
  },
  {
    name: "business-orders-reports",
    path: "/business/orders/reports",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/orders/reports.vue")
  },
  {
    name: "business-signage-promos",
    path: "/business/signage/promos",
    meta: { ...(promoslcCXsh3j_h1WQWIZTdSRz8kj_VBOxYiGg5_dY1nlj_4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/promos.vue")
  },
  {
    name: "business-configure-kiosk",
    path: "/business/configure/kiosk",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/kiosk.vue")
  },
  {
    name: "business-floorplan",
    path: "/business/floorplan",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/floorplan/index.vue")
  },
  {
    name: "business-inventory",
    path: "/business/inventory",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/inventory/index.vue")
  },
  {
    name: "business-marketing",
    path: "/business/marketing",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/marketing/index.vue")
  },
  {
    name: "business-menu-categories",
    path: "/business/menu/categories",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/categories.vue")
  },
  {
    name: "business-menu-list",
    path: "/business/menu/list",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/list/index.vue")
  },
  {
    name: "business-payment-methods",
    path: "/business/payment-methods",
    meta: payment_45methodsvDFI_wdqykJIyF_1tZjWxp4ey1dvXEMZsWJ5cmJ8p5QMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/payment-methods.vue")
  },
  {
    name: "business-signage-content",
    path: "/business/signage/content",
    meta: { ...(contentDnyDeEhDuUtI9GxX5kWETYBGR_v5UJI18aF_r_NROgoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/content.vue")
  },
  {
    name: "features-menu-management",
    path: "/features/menu-management",
    meta: menu_45managementic9gh_h9CZMFlWdwqrhtrKN_M6JB77s_oPClUNfa7dsMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/menu-management.vue")
  },
  {
    name: "features-online-ordering",
    path: "/features/online-ordering",
    meta: online_45orderingVQ5M_IhzUygscex3nR_mVyr31A56GLfJHqdM_eDgEwgMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/online-ordering.vue")
  },
  {
    name: "my-payment-methods",
    path: "/my/payment-methods",
    meta: indexNpkBURv7codJKJl4tdPKpR1bQZeR3DJLt4RVmZdkWY0Meta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/my/payment-methods/index.vue")
  },
  {
    name: "business-floorplan-labels",
    path: "/business/floorplan/labels",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/floorplan/labels.vue")
  },
  {
    name: "business-menu-id-modify",
    path: "/business/menu/:id()/modify",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/menu/[id]/modify.vue")
  },
  {
    name: "features-staff-management",
    path: "/features/staff-management",
    meta: staff_45management0fGDez4FesOvYKj5pNKtY2FWnlrD1aoYQP4S8Hkh2kIMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/staff-management.vue")
  },
  {
    name: "business-businessId-fees",
    path: "/business/:businessId()/fees",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/fees.vue")
  },
  {
    name: "business-crm-loyalty",
    path: "/business/crm/loyalty",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/loyalty/index.vue")
  },
  {
    name: "business-marketing-reports",
    path: "/business/marketing/reports",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/marketing/reports.vue")
  },
  {
    name: "business-payment-terminals",
    path: "/business/payment-terminals",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/payment-terminals.vue")
  },
  {
    name: "business-signage-analytics",
    path: "/business/signage/analytics",
    meta: { ...(analyticsZdhLySYarKydM9kAoasEYof26Bm69NKwHvvNGn7g5goMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/analytics.vue")
  },
  {
    name: "business-billing-statements",
    path: "/business/billing-statements",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/billing-statements.vue"),
    children: [
  {
    name: "business-billing-statements-id",
    path: ":id()",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/billing-statements/[id].vue")
  }
]
  },
  {
    name: "business-configure-trackers",
    path: "/business/configure/trackers",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/trackers.vue")
  },
  {
    name: "business-crm-campaigns-id",
    path: "/business/crm/campaigns/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/campaigns/[id].vue")
  },
  {
    name: "business-crm-customers-id",
    path: "/business/crm/customers/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/customers/[id].vue")
  },
  {
    name: "business-crm-templates-id",
    path: "/business/crm/templates/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/templates/[id].vue")
  },
  {
    name: "business-configure-patronect",
    path: "/business/configure/patronect",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/patronect.vue")
  },
  {
    name: "business-crm-campaigns",
    path: "/business/crm/campaigns",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/campaigns/index.vue")
  },
  {
    name: "business-crm-customers",
    path: "/business/crm/customers",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/customers/index.vue")
  },
  {
    name: "business-crm-templates",
    path: "/business/crm/templates",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/templates/index.vue")
  },
  {
    name: "business-orders-ws-simulator",
    path: "/business/orders/ws-simulator",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/orders/ws-simulator.vue")
  },
  {
    name: "business-payment-allocations",
    path: "/business/payment-allocations",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/payment-allocations.vue")
  },
  {
    name: "features-delivery-management",
    path: "/features/delivery-management",
    meta: delivery_45management2BiA0c_8wnh_C3YbSGAaakQrdHYkQtngC2qrc0qEJM4Meta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/delivery-management.vue")
  },
  {
    name: "business-businessId-courses",
    path: "/business/:businessId()/courses",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/courses.vue")
  },
  {
    name: "business-crm-campaigns-create",
    path: "/business/crm/campaigns/create",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/campaigns/create.vue")
  },
  {
    name: "business-crm-templates-create",
    path: "/business/crm/templates/create",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/crm/templates/create.vue")
  },
  {
    name: "business-signage-promo-editor",
    path: "/business/signage/promo-editor",
    meta: { ...(promo_45editorhKuEBrIcsfDC8Q0YFR6U9gW3UzKzjG1fFUSjExrSr9oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/promo-editor.vue")
  },
  {
    name: "business-signage-templates-id",
    path: "/business/signage/templates/:id()",
    meta: { ...(_91id_93qklX2G4yhiaTdDY_bTAbVGZha9brdq619vOaqbwIPe0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/templates/[id].vue")
  },
  {
    name: "features-customer-relationships",
    path: "/features/customer-relationships",
    meta: customer_45relationshipsQPoLfNp2XSz0L5VTuumY9F3Go64A06GkYssV1lLER8QMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/features/customer-relationships.vue")
  },
  {
    name: "business-configure-order-tablets",
    path: "/business/configure/order-tablets",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/configure/order-tablets.vue")
  },
  {
    name: "business-signage-templates",
    path: "/business/signage/templates",
    meta: { ...(indexZHWzPOhiNiFfWICIOTPErVWZwxaCJg946zZmanWyikYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/templates/index.vue")
  },
  {
    name: "business-signage-menu-boards-id",
    path: "/business/signage/menu-boards/:id()",
    meta: { ...(_91id_93Roo1ydFRY1Lv0hI0wv5shW5x7PLdjpvOqRUuV75n1nIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/menu-boards/[id].vue")
  },
  {
    name: "business-businessId-integrations",
    path: "/business/:businessId()/integrations",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/integrations.vue")
  },
  {
    name: "business-businessId-reservations",
    path: "/business/:businessId()/reservations",
    meta: {"middleware":"auth"},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/reservations.vue")
  },
  {
    name: "business-signage-menu-boards",
    path: "/business/signage/menu-boards",
    meta: { ...(indexfA_M0jTdt48W9rZRwf_bV_f24gHbmfqvtAr1xp0zCusMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/signage/menu-boards/index.vue")
  },
  {
    name: "business-manager-staff-hours-report",
    path: "/business/manager/staff-hours-report",
    meta: staff_45hours_45reportHKU_1qnGNpV75axV10L91zR7donOND1PKuahqBjysi8Meta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/manager/staff-hours-report.vue")
  },
  {
    name: "business-id-payment-reconciliation",
    path: "/business/:id()/payment-reconciliation",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[id]/payment-reconciliation.vue")
  },
  {
    name: "business-businessId-operating-hours",
    path: "/business/:businessId()/operating-hours",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/operating-hours.vue")
  },
  {
    name: "business-businessId-payment-connect",
    path: "/business/:businessId()/payment-connect",
    meta: payment_45connectCNo4KlEPEbj_XVvODXaWHDo8SQsLhQfHV_Oo4OW0MBgMeta || {},
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/payment-connect.vue")
  },
  {
    name: "business-businessId-booking-settings",
    path: "/business/:businessId()/booking-settings",
    component: () => import("/var/www/starvly/releases/20260930-211419/starvly-platform/packages/web-ui/pages/business/[businessId]/booking-settings.vue")
  }
]